import React from 'react';
import { Field } from 'react-final-form';
import { useIntl } from 'react-intl';

import { ITEM_MAX_IMAGE_COUNT } from 'modules/menu/constants';
import ImageView from 'modules/menu/items/components/Item/ItemDetails/ImageView';
import { useOfferingMenuPermissionsContext } from 'modules/shared-menu/contexts/OfferingMenuPermissionsContext';

import { BaseField } from './types';
import { FormRowRenderer } from '../FormRowRenderer';
import { DisplayText, StyledInputContainer, StyledMultiImageUploadInput } from '../OfferDetailsFormFields.styles';
import { BasicDetails } from '../types';

export const Images = ({ sidePanelMode, offer }: BaseField) => {
  const menuPermissions = useOfferingMenuPermissionsContext();
  const intl = useIntl();

  const previewComponent =
    !offer?.image && !offer?.images?.length ? <DisplayText>-</DisplayText> : <ImageView item={offer} />;

  const editComponent = (
    <Field<BasicDetails['image']> name="image">
      {({ input }) => {
        return (
          <StyledInputContainer>
            <StyledMultiImageUploadInput {...input} imageCountLimit={ITEM_MAX_IMAGE_COUNT} />
          </StyledInputContainer>
        );
      }}
    </Field>
  );

  return (
    <FormRowRenderer
      hasContentEditPermission={menuPermissions.contentEdit}
      label={intl.formatMessage({ id: 'menu-item.image' })}
      previewComponent={previewComponent}
      editComponent={editComponent}
      sidePanelMode={sidePanelMode}
      offer={offer}
    />
  );
};
